import { Map } from 'immutable';

export type DiagnosticErrorType = 'critic' | 'warning';

export const ErrorTypeOrder: Record<DiagnosticErrorType, number> = {
	critic: 0,
	warning: 1,
};

export enum ExpositionErrorKey {
	// Step 1 - Datablock
	NoDatablockSelection = 'no-datablock-selection',
	// Step 2 - Metadata
	ExpositionMetadataMissingFields = 'exposition-metadata-missing-fields',
	ExpositionMetadataNotValid = 'exposition-metadata-not-valid',
	EndpointMetadataMissingFields = 'endpoint-metadata-missing-fields',
	EndpointMetadataNotValid = 'endpoint-metadata-not-valid',
	// Step 3 - Columns
	NoActiveColumns = 'no-active-columns',
	InvalidColumns = 'invalid-columns',
	DuplicatedAliasColumns = 'duplicated-alias-columns',
	// Step 4 - Access
	AccessMetadataMissingFields = 'access-metadata-missing-fields',
	NoActiveAccessColumns = 'no-active-access-columns',
	NoSelectAccessConsumers = 'no-select-access-consumers',
}

export interface IExpositionDiagnosticError {
	key: string;
	type: DiagnosticErrorType;
	message: string;
}

export class ExpositionDiagnosticError implements IExpositionDiagnosticError {
	public readonly key: string;
	public readonly type: DiagnosticErrorType;
	public readonly message: string;

	public static build(
		params: Partial<IExpositionDiagnosticError>
	): ExpositionDiagnosticError {
		return new ExpositionDiagnosticError(params);
	}

	private constructor(params: Partial<IExpositionDiagnosticError>) {
		this.key = params.key ?? '';
		this.type = params.type ?? 'critic';
		this.message = params.message ?? '';
	}
}
